import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { PaymentCompletedCB } = await import('@containers/Payment/CleverBridgePaymentCompleted');
    return {
        Component: PaymentCompletedCB,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
